// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3oBoc","content":"styles_content__xqVi8","checkbox":"styles_checkbox__2tz2I","checkboxLabel":"styles_checkboxLabel__2sqDI"};